
import { getTranslate } from "react-localize-redux";
import Cookies from 'universal-cookie';
import { writeDebug, writeErr } from "../../../components/common/logger";
import { apiPost, getHostApi } from "../../apiWrapper";
import { diagram } from "../diagram/initial";

// FUNCTIONS
// LOG
function _eventLoggerSend(name, value) {
    apiPost(`${getHostApi()}/api/charts/log-event`, undefined, { eventName: name, eventValue: value || '' },
        _ => writeDebug(`log-event eventName: ${name}, eventValue: ${value || ''}`)
    );
}

// ERROR
function _handleError(msg, err, getState) {
    writeErr(msg, err);
    if (typeof diagram._showInformationMessagePopupFunc === 'function')
        diagram._showInformationMessagePopupFunc(getTranslate(getState().localize)(err ? err.data.error.message : 'UnhappyUser.InternalServerError'));
}

// COOKIE 
function _setCookie(name, val) {
    const ck = new Cookies();
    ck.set(name, val, { secure: true, expires: new Date(2040, 0, 1) });
}

// DATE
function _parseDate(dateStr) {
    if (dateStr == null || dateStr == undefined)
        return null;
    else if (dateStr.indexOf('.') >= 0) {
        var s = dateStr.split('.');
        return new Date(Number(s[2].trim()), Number(s[1].trim()) - 1, Number(s[0].trim()));
    }
    else if (dateStr.indexOf('/') >= 0) {
        var s = dateStr.split('/');
        return new Date(Number(s[2].trim()), Number(s[0].trim()) - 1, Number(s[1].trim()));
    }
    else if (dateStr.indexOf('-') >= 0) {
        var s = dateStr.split('-');
        return new Date(Number(s[0].trim()), Number(s[1].trim()) - 1, Number(s[2].trim()));
    }
    else return null;
}

function _formatDate(date) {
    if (date != null) {
        return date.getFullYear() + '-' + (date.getMonth() + 1) + "-" + date.getDate();
    } else {
        return "";
    }
}


// OTHER
function _unique(array) {
    return array.filter(function (el, index) {
        return index == array.indexOf(el);
    });
}

function _emptyIfNull(data) {
    if (data === undefined || data === null) return '';
    return data;
}

export {
    _emptyIfNull, _eventLoggerSend, _formatDate, _handleError, _parseDate, _setCookie, _unique
};
